export const Arr_SEFPages = [
  {
    label: "Basic Info",
    Prop: "BasicInfo",
    link: "ViewSEFBasicInfo",
    level: "Basic",
    MongoDB: "BasicInfo",
    Column: 1,
    Medical: "No",
  },
  {
    label: "Contact Info",
    Prop: "ContactInfo",
    link: "ViewSEFContactInfo",
    level: "Basic",
    MongoDB: "Contacts",
    Column: 4,
    Medical: "No",
  },
  {
    label: "General Info",
    Prop: "GeneralInfo",
    link: "ViewSEFGeneralInfo",
    level: "Basic",
    MongoDB: "SEFGeneralInfo",
    Column: 1,
    Medical: "No",
  },
  {
    label: "VISA Status",
    Prop: "VISAInfo",
    link: "ViewSEFVISAInfo",
    level: "Basic",
    MongoDB: "VISA",
    Column: 4,
    Medical: "No",
  },
  {
    label: "Photos",
    Prop: "PhotosInfo",
    link: "ViewSEFPhotosInfo",
    level: "Basic",
    MongoDB: "Photos",
    Column: 4,
    Medical: "No",
  },
  {
    label: "Food Allergies & Dietary Information",
    Prop: "AllergiesDietaryInfo",
    link: "ViewSEFAllergiesDietaryInfo",
    level: "Advanced",
    MongoDB: "SEFAllergiesDietaryInfo",
    Column: 3,
    Medical: "Yes",
  },

  {
    label: "Non-Food Allergy Information",
    Prop: "NonFoodAllergiesInfo",
    link: "ViewSEFNonFoodAllergiesInfo",
    level: "Advanced",
    MongoDB: "SEFNonFoodAllergiesInfo",
    Column: 3,
    Medical: "Yes",
  },
  {
    label: "Physical Health",
    Prop: "PhysicalHealthInfo",
    link: "ViewSEFPhysicalHealthInfo",
    level: "Advanced",
    MongoDB: "SEFPhysicalHealthInfo",
    Column: 2,
    Medical: "Yes",
  },
  {
    label: "Mental Health",
    Prop: "MentalHealthInfo",
    link: "ViewSEFMentalHealthInfo",
    level: "Advanced",
    MongoDB: "SEFMentalHealthInfo",
    Column: 2,
    Medical: "Yes",
  },
  {
    label: "SEND",
    Prop: "SENDInfo",
    link: "ViewSEFSENDInfo",
    level: "Advanced",
    MongoDB: "SEFSENDInfo",
    Column: 2,
    Medical: "Yes",
  },
  {
    label: "Other Medications",
    Prop: "MedicationsInfo",
    link: "ViewSEFMedicationsInfo",
    level: "Advanced",
    MongoDB: "SEFMedicationsInfo",
    Column: 3,
    Medical: "Yes",
  },
  {
    label: "Declarations",
    Prop: "DeclarationsInfo",
    link: "ViewSEFDeclarationsInfo",
    level: "Advanced",
    MongoDB: "SEFDeclarationsInfo",
    Column: 1,
    Medical: "No",
  },
];
